import PropTypes from "prop-types";
import React from "react";

const ToolbarTextSlugButton = props => (
  <div
    id={props.id ? props.id : null}
    className={`toolbarTextSlugBtn ${props.color ? props.color : ""} ${props.disabled ? "disabled" : ""} `}
    onClick={props.disabled ? null : props.onClick}
  >
    <span>{props.text}</span>
  </div>
);

ToolbarTextSlugButton.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  id: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool
};

export default ToolbarTextSlugButton;
